module.exports = __webpack_public_path__ + "28da61ae6715dcdfa064c25cdc702b4e.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/angry-1.png
// module id = 2034
// module chunks = 0